export default __webpack_public_path__ + "static/media/dopes1.7031f581.jfif";